import { InvoiceDetailsView } from "@portal/BaseComponents/DetailsView/InvoiceDetailsView/InvoiceDetailsView";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { Col, Row } from "@portal/BaseComponents/Grid/AntGrid";
import { AdditionalInformation } from "./Cards/AdditionalInformationCard/AdditionalInformation";
import { InternalContacts } from "./Cards/ClientContactsCard/InternalContacts";
import { ContactAddress } from "./Cards/ContactAddressCard/ContactAddress";
import { CustomerContacts } from "./Cards/CustomerContactsCard/CustomerContactList";

function ProfileTab() {
  return (
    <>
      <Flex
        style={{ padding: "var(--space-24) 0 80px 0" }}
        space={"20"}
        justify="center"
      >
        <Row style={{ flexDirection: "column" }} gutter={[0, 20]}>
          <Col>
            <CustomerContacts />
          </Col>
          <Col>
            <ContactAddress />
          </Col>
        </Row>
        <Row style={{ flexDirection: "column" }} gutter={[0, 20]}>
          <Col>
            <InternalContacts />
          </Col>
          <Col>
            <AdditionalInformation />
          </Col>
        </Row>
      </Flex>
      <InvoiceDetailsView />
    </>
  );
}
export { ProfileTab };
